/**
 * FANDERA — motor de motion design.
 *
 * Se apaga solo (sin añadir `js-motion-ready`) si:
 *   - el ajuste del tema "Animaciones" está en Desactivada (html[data-motion="off"]), o
 *   - el usuario tiene prefers-reduced-motion activo.
 * En ambos casos el contenido ya es visible por defecto vía motion.css, así
 * que no hace falta ninguna otra rama de seguridad: simplemente no se activa
 * el sistema de reveals.
 */
(function () {
  var html = document.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var motionOff = html.getAttribute('data-motion') === 'off';

  if (reduceMotion || motionOff) return;
  if (!('IntersectionObserver' in window)) return;

  html.classList.add('js-motion-ready');

  var REVEAL_SELECTOR = '.motion-reveal, .motion-reveal-up, .motion-reveal-left, .motion-reveal-right, .motion-image, .motion-line';

  var revealObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
  );

  function assignStagger(container) {
    var items = container.querySelectorAll(':scope > [data-motion-index]');
    items.forEach(function (item) {
      var index = parseInt(item.getAttribute('data-motion-index'), 10) || 0;
      item.style.setProperty('--motion-delay', index * 90 + 'ms');
    });
  }

  function observeNewElements(root) {
    root.querySelectorAll('[data-motion-stagger]').forEach(assignStagger);
    root.querySelectorAll(REVEAL_SELECTOR).forEach(function (el) {
      if (el.dataset.motionObserved) return;
      el.dataset.motionObserved = 'true';
      revealObserver.observe(el);
    });
  }

  observeNewElements(document);

  /* Hero: plays on load, not on scroll-into-view. */
  function playHero(root) {
    root.querySelectorAll('[data-motion-hero]').forEach(function (hero) {
      if (hero.dataset.motionHeroPlayed) return;
      hero.dataset.motionHeroPlayed = 'true';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          hero.classList.add('motion-hero-ready');
        });
      });
    });
  }

  playHero(document);

  /* ---------------------------------------------------------------------
   * Parallax — desktop only, extremely light, gated by viewport + motion.
   * ------------------------------------------------------------------- */
  var parallaxEls = [];
  var parallaxTicking = false;
  var parallaxMql = window.matchMedia('(min-width: 990px)');

  function collectParallaxEls() {
    parallaxEls = Array.prototype.slice.call(document.querySelectorAll('.motion-parallax'));
  }

  function updateParallax() {
    parallaxTicking = false;
    if (!parallaxMql.matches) return;
    var viewportH = window.innerHeight;
    var viewportCenter = viewportH / 2;
    parallaxEls.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > viewportH) return;
      var elCenter = rect.top + rect.height / 2;
      var progress = (viewportCenter - elCenter) / viewportH;
      var offset = Math.max(-20, Math.min(20, progress * 40));
      el.style.transform = 'translateY(' + offset.toFixed(1) + 'px)';
    });
  }

  function onScrollOrResize() {
    if (!parallaxMql.matches || parallaxEls.length === 0) return;
    if (parallaxTicking) return;
    parallaxTicking = true;
    requestAnimationFrame(updateParallax);
  }

  collectParallaxEls();
  if (parallaxEls.length > 0) {
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize, { passive: true });
    updateParallax();
  }

  /* ---------------------------------------------------------------------
   * Shopify theme editor: re-scan reloaded sections, no duplicate init.
   * ------------------------------------------------------------------- */
  document.addEventListener('shopify:section:load', function (event) {
    observeNewElements(event.target);
    playHero(event.target);
    collectParallaxEls();
    updateParallax();
  });

  document.addEventListener('shopify:section:unload', function () {
    collectParallaxEls();
  });

  document.addEventListener('shopify:block:select', function (event) {
    var el = event.target.closest(REVEAL_SELECTOR);
    if (el) el.classList.add('is-visible');
  });
})();
